/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React from 'react';
import { jsx, css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { ForgeHeaderModule } from 'view/forge-ui/portal-header';

const zeroSpace = token('space.0', '0px');

const containerStyles = css({
	width: '100%',
	marginTop: zeroSpace,
	marginRight: zeroSpace,
	marginBottom: zeroSpace,
	marginLeft: zeroSpace,
	paddingTop: zeroSpace,
	paddingRight: zeroSpace,
	paddingBottom: zeroSpace,
	paddingLeft: zeroSpace,
});

/**
 * ForgePortalHeaderModule renders the Forge portal header app
 * as the sole content of the help center, with no padding or constraints.
 */
export const ForgePortalHeaderModule: React.FC = () => {
	return (
		<div css={containerStyles}>
			<ForgeHeaderModule page="portal" noWrapper allowCustomPadding={false} />
		</div>
	);
};

export default ForgePortalHeaderModule;
